import Text from '@/components/text';
import { alpha, Box, Stack, Theme } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: Theme) => ({
  datasourceOpt: {
    width: '100%',
    padding: 4,
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
    border: '1px solid transparent',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.selected': {
      backgroundColor: theme.palette.surface.info.main,
      borderColor: alpha(theme.palette.primary.main, 0.2),
    },
  },
}));

interface Props {
  id: string;
  name: string;
  onChange: (datasourceId: string) => void;
  selected: boolean;
  IconEl?: ReactNode;
}

const CardOpt: FC<Props> = ({ id, name, onChange, selected, IconEl }) => {
  const styles = useStyles();
  const compClass = classNames(styles.datasourceOpt, { selected });

  return (
    <Stack id={id} className={compClass} role="button" onClick={() => onChange(id)}>
      <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1} minWidth={0}>
        {IconEl}
        <Box flexGrow={1} minWidth={0}>
          <Text dotdot>{name}</Text>
        </Box>
      </Stack>
    </Stack>
  );
};

export default CardOpt;
